import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosError } from "axios";
import { CompanyBlockUnblockValidationSchema } from "../schemas/blockUnblockCompany.schema";

interface UseDisableCompanyProps {
  companyId?: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

const useDisableClientCompany = ({ companyId, onSuccess, onError }: UseDisableCompanyProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation<void, AxiosError, CompanyBlockUnblockValidationSchema>({
    mutationKey: ['disableCompany', companyId],
    mutationFn: async (data) => {
      await privateAxios.put(`/client/companies/${companyId}/disable`, {
        company: data,
      });
    },
    onSuccess,
    onError,
  });
};

export default useDisableClientCompany;
